
import { Component, Prop, Vue } from 'vue-property-decorator'
import Group from './group/index.vue'
import Area from './area/index.vue'
import IssueType from './issueType/index.vue'
import ComputerModel from './computerModel/index.vue'
import TeamInfoModel from './team/index.vue'
import WorkDayModel from './workday/index.vue'
import Remind from './remind/index.vue'
import {
  isItTicketType,
  isNetworkTicketType,
  isAdministrationTicketType, isLiveType
} from '@/utils/commonFunc'
import CommonType from '@/views/config/commontype/index.vue'

@Component({
  name: 'tutorConfig',
  components: {
    CommonType,
    Group,
    Area,
    IssueType,
    ComputerModel,
    TeamInfoModel,
    WorkDayModel,
    Remind
  }
})
export default class extends Vue {
  private activeName = 'group';
  private tableHeight = 200;

  get isItTicketType() {
    return isItTicketType()
  }

  get isAdministrationTicketType() {
    return isAdministrationTicketType()
  }

  get isLiveTicketType() {
    return isLiveType()
  }

  get isNetworkTicketType() {
    return isNetworkTicketType()
  }

  mounted() {
    const resizeEvt =
      'orientationchange' in window ? 'orientationchange' : 'resize'
    window.addEventListener(
      resizeEvt,
      () => {
        this.tableHeight = window.innerHeight - 109
      },
      false
    )
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 109
    })
  }

  private handleClick() {
    this.$router.push({ name: 'tutorConfig' })
  }
}
